import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

export const getBlockUserList = createAsyncThunk("getBlockUserList", async () => {
    const response = await axiosInstance.get(`/blocked-users/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const accountUnBlockUser = createAsyncThunk(
    "accountUnBlockUser", async (id) => {
        const response = await axiosInstance.post(`/unblock/${id}/`, {});
        try {
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

export const accountBlockUser = createAsyncThunk(
    "accountBlockUser", async (id) => {
        const response = await axiosInstance.post(`/block/${id}/`, {});
        try {
            const result = response.data;
            return result;
        } catch (error) {

            return error;
        }
    }
);

export const BlockSlice = createSlice({
    name: "BlockSlice",
    initialState: {
        loading: false,
        blockLoading: false,
        error: null,
        data: [],
    },
    extraReducers: (builder) => {

        builder.addCase(getBlockUserList.pending, (state) => {
            state.loading = true;
            state.data = [];
        });
        builder.addCase(getBlockUserList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.map((item) => ({
                id: item.id,
                full_name: item.full_name,
                avatar: item.avatar,
                is_blocked: true,
            }));
            state.error = null;
        });
        builder.addCase(getBlockUserList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        //
        builder.addCase(accountUnBlockUser.pending, (state) => {
            state.blockLoading = true;
            state.error = null;
        });

        builder.addCase(accountUnBlockUser.fulfilled, (state, action) => {
            state.blockLoading = false;
            state.data = state.data.map((user) =>
                user.id === action.payload.id
                    ? { ...user, is_blocked: false }
                    : user
            );
            state.error = null;
        });

        builder.addCase(accountUnBlockUser.rejected, (state, action) => {
            state.blockLoading = false;
            state.error = action.payload;
        });

        /// Block User
        builder.addCase(accountBlockUser.pending, (state) => {
            state.blockLoading = true;
            state.error = null;
        });

        builder.addCase(accountBlockUser.fulfilled, (state, action) => {
            state.blockLoading = false;
            state.data = state.data.map((user) =>
                user.id === action.payload.id
                    ? { ...user, is_blocked: true }
                    : user
            );
            state.error = null;
        }
        );
        builder.addCase(accountBlockUser.rejected, (state, action) => {
            state.blockLoading = false;
            state.error = action.payload;
        });

    },
});

export default BlockSlice.reducer;
